/*updating header icon qty upon load, should it not match the cart content*/
$(function(){
updateiconqty();
});

//true cart page function means skipping to cart page upon header icon click
$(".header__icon--cart").click(function(e){
  e.preventDefault(); 
  e.stopPropagation(); 
  e.stopImmediatePropagation(); 
  window.location.href="/cart";
});


//back-forward cache on mobile
window.onpageshow = function(event) {
    if (event.persisted) {
updateiconqty();
    }
};

function updateiconqty(){
    $.getJSON('/cart.js', function(cart) {
    var qty = cart.item_count;
    $("#cart-icon-bubble span").html(qty);
    });
  
}